import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObservableService {

  private platformReady = new Subject<void>();
  public readonly platformReady$ = this.platformReady.asObservable();

  private onAuthStateChanged = new Subject<void>();
  public readonly onAuthStateChanged$ = this.onAuthStateChanged.asObservable();

  private onAppointmentCreate = new Subject<string>();
  public readonly onAppointmentCreate$ = this.onAppointmentCreate.asObservable();

  private onAppointmentDelete = new Subject<void>();
  public readonly onAppointmentDelete$ = this.onAppointmentDelete.asObservable();

  private onAppointmentUpdate = new Subject<string>();
  public readonly onAppointmentUpdate$ = this.onAppointmentUpdate.asObservable();

  private onClientCreate = new Subject<string>();
  public readonly onClientCreate$ = this.onClientCreate.asObservable();

  private onClientEdit = new Subject<string>();
  public readonly onClientEdit$ = this.onClientEdit.asObservable();

  private onClientDelete = new Subject<string>();
  public readonly onClientDelete$ = this.onClientDelete.asObservable();

  private onOnboardingAction = new Subject<string>();
  public readonly onOnboardingAction$ = this.onOnboardingAction.asObservable();

  private onPayment = new Subject<any>();
  public readonly onPayment$ = this.onPayment.asObservable();

  private onCheckout = new Subject<string>();
  public readonly onCheckout$ = this.onCheckout.asObservable();

  private onSubscriptionNeeded = new Subject<void>();
  public readonly onSubscriptionNeeded$ = this.onSubscriptionNeeded.asObservable();

  constructor() { }

  public publishPlatformReady() {
    this.platformReady.next();
  }

  public publishAuthStateChanged() {
    this.onAuthStateChanged.next();
  }
  
  public publishAppointmentCreate(appointment) {
    this.onAppointmentCreate.next(appointment);
  }
  
  public publishAppointmentDelete() {
    this.onAppointmentDelete.next();
  }
  
  public publishAppointmentUpdate(appointment) {
    this.onAppointmentUpdate.next(appointment);
  }
  
  public publishClientCreate(client) {
    this.onClientCreate.next(client);
  }
  
  public publishClientEdit(id: string) {
    this.onClientEdit.next(id);
  }
  
  public publishClientDelete(id: string) {
    this.onClientDelete.next(id);
  }  
  
  public publishOnboardingAction(id: string) {
    this.onOnboardingAction.next(id);
  }   
  
  public publishOnPayment(data?: any) {
    this.onPayment.next(data);
  }    
  
  public publishOnCheckout(id?: string) {
    this.onCheckout.next(id);
  }
  
  public publishOnSubscriptionNeeded() {
    this.onSubscriptionNeeded.next();
  }
}
